const MENSAGENS_GENERICAS = [
  "check the inconsistencies noted below",
  "validation error",
  "error",
  "erro",
];

function valorPreenchido(valor) {
  return typeof valor === "string" && valor.trim().length > 0;
}

function dadosDaResposta(origem) {
  if (origem?.response?.data) {
    return origem.response.data;
  }

  if (origem?.data && typeof origem.data === "object") {
    return origem.data;
  }

  return origem || {};
}

function mensagemGenerica(mensagem) {
  if (!valorPreenchido(mensagem)) {
    return true;
  }

  return MENSAGENS_GENERICAS.includes(mensagem.trim().toLowerCase());
}

function mensagemTecnica(mensagem) {
  const contemNamespaceDeSchema = /Element '\{https?:\/\/[^}]+\}/i.test(
    mensagem
  );

  return (
    /during\s+\[(?:GET|POST|PUT|PATCH|DELETE)\]\s+to\s+\[/i.test(mensagem) ||
    (!contemNamespaceDeSchema && /https?:\/\//i.test(mensagem)) ||
    /token=/i.test(mensagem) ||
    /Request failed with status code/i.test(mensagem) ||
    /#[a-zA-Z0-9_]+\s*\(/.test(mensagem)
  );
}

function tentarInterpretarJson(texto) {
  const textoLimpo = texto.trim();

  try {
    return JSON.parse(textoLimpo);
  } catch (error) {
    // A Focus inclui o JSON depois do contexto técnico do cliente HTTP.
  }

  const inicioArray = texto.lastIndexOf("[{");
  const fimArray = texto.lastIndexOf("}]");
  if (inicioArray >= 0 && fimArray > inicioArray) {
    try {
      return JSON.parse(texto.slice(inicioArray, fimArray + 2));
    } catch (error) {
      // Continua para a tentativa com objeto simples.
    }
  }

  const inicioObjeto = texto.lastIndexOf('{"');
  const fimObjeto = texto.lastIndexOf("}");
  if (inicioObjeto >= 0 && fimObjeto > inicioObjeto) {
    try {
      return JSON.parse(texto.slice(inicioObjeto, fimObjeto + 1));
    } catch (error) {
      return null;
    }
  }

  return null;
}

function formatarErroSchema(linha) {
  const linhaLimpa = linha
    .trim()
    .replace(/^\d+:\d+:\s*ERROR:\s*/i, "")
    .replace(/^ERROR:\s*/i, "");
  const campo = linhaLimpa.match(/Element '\{[^}]+\}([^']+)'/i)?.[1];
  const erroFormato = linhaLimpa.match(
    /\[facet 'pattern'\]\s*The value '([^']*)' is not accepted by the pattern '([^']*)'\.?/i
  );

  if (campo && erroFormato) {
    return `${campo}: o valor "${erroFormato[1]}" não atende ao formato esperado ${erroFormato[2]}.`;
  }

  const campoEsperado = linhaLimpa.match(
    /This element is not expected\.\s*Expected is\s*\(\s*\{[^}]+\}([^\s)]+)\s*\)\.?/i
  )?.[1];

  if (campo && campoEsperado) {
    return `${campo}: campo inesperado. Era esperado: ${campoEsperado}.`;
  }

  return linhaLimpa.replace(/\{https?:\/\/[^}]+\}/gi, "").trim();
}

function mensagensDoTexto(texto) {
  if (!valorPreenchido(texto)) {
    return [];
  }

  const json = tentarInterpretarJson(texto);
  if (json !== null) {
    return mensagensDoPayload(json);
  }

  if (mensagemTecnica(texto)) {
    return [];
  }

  return texto
    .split(/\r?\n/)
    .map(formatarErroSchema)
    .filter(
      (mensagem) => valorPreenchido(mensagem) && !mensagemGenerica(mensagem)
    );
}

function mensagensDoPayload(payload) {
  if (Array.isArray(payload)) {
    return payload.flatMap(mensagensDoPayload);
  }

  if (typeof payload === "string") {
    return mensagensDoTexto(payload);
  }

  if (!payload || typeof payload !== "object") {
    return [];
  }

  const mensagem =
    payload.mensagem ||
    payload.message ||
    payload.descricao ||
    payload.complemento;
  const mensagens = mensagensDoTexto(mensagem);
  const codigo = payload.codigo || payload.code;
  const campo = valorPreenchido(payload.fieldName)
    ? payload.fieldName.trim()
    : null;

  if (/^E\d+$/i.test(codigo || "") && mensagens.length > 0) {
    mensagens[0] = `${codigo} - ${mensagens[0]}`;
  }

  if (campo && !["error", "data integrity"].includes(campo.toLowerCase())) {
    return mensagens.map((item) =>
      item.startsWith(`${campo}:`) ? item : `${campo}: ${item}`
    );
  }

  return mensagens;
}

function removerDuplicadas(mensagens) {
  return [...new Set(mensagens.map((mensagem) => mensagem.trim()))];
}

function detalhesDaUltimaMovimentacao(documento) {
  if (
    documento?.statusDocumento !== "NAOAUTORIZADO" ||
    !Array.isArray(documento?.movimentacoes)
  ) {
    return [];
  }

  const movimentacao = [...documento.movimentacoes]
    .reverse()
    .find((item) => valorPreenchido(item?.detalhes));

  return mensagensDoTexto(movimentacao?.detalhes);
}

export function mensagensErroIntegracaoFiscal(origem, fallback) {
  const dados = dadosDaResposta(origem);
  const detalhes = Array.isArray(dados?.errors)
    ? dados.errors.flatMap((erro) => mensagensDoPayload(erro))
    : [];
  const movimentacao = detalhesDaUltimaMovimentacao(dados);
  const mensagensDetalhadas = removerDuplicadas([...detalhes, ...movimentacao]);

  if (mensagensDetalhadas.length > 0) {
    return mensagensDetalhadas;
  }

  const mensagensPrincipais = mensagensDoTexto(dados?.message);
  if (mensagensPrincipais.length > 0) {
    return removerDuplicadas(mensagensPrincipais);
  }

  const mensagemDaExcecao = mensagensDoTexto(origem?.message);
  if (mensagemDaExcecao.length > 0) {
    return removerDuplicadas(mensagemDaExcecao);
  }

  return valorPreenchido(fallback) ? [fallback] : [];
}

export function mensagemErroIntegracaoFiscal(origem, fallback) {
  return mensagensErroIntegracaoFiscal(origem, fallback).join(" • ");
}

export function integracaoFiscalRejeitada(documento) {
  return documento?.statusDocumento === "NAOAUTORIZADO";
}
